import { ModalConfig, ModalFactory } from '@rendora/common/features/modals/factory';
import { VNode } from 'vue';
import PaymentModal, { type PaymentModalProps } from './index.vue';

export const showPaymentModal = (
  content: VNode,
  config: PaymentModalProps,
  symbol?: symbol,
  modalConfig?: ModalConfig,
) => {
  ModalFactory.clear();

  return ModalFactory.create(
    {
      border: 'none',
      background: 'transparent',
      borderRadius: '0px',
      padding: 0,
      showHeader: false,
      showCloseButton: false,
      closeOnOverlayClick: false,
      closeOnEsc: false,
      width: 'auto',
      ...modalConfig,
      content: <PaymentModal {...config}>{content}</PaymentModal>,
    },
    symbol,
  );
};
